import { configureStore } from '@reduxjs/toolkit';
import userManagementReducer from './userManagementSlice.ts';
import { baseApi } from './baseApi';
import '@/features/UserManagement/services/usersApi.ts';
import '@/features/Docs&Policies/services/documents/documentsApi.ts';
import '@/features/RiskManagement/services/riskApis.ts';

export const store = configureStore({
  reducer: {
    userManagement: userManagementReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
